module.exports = __webpack_public_path__ + "img/format_strikethrough.d29631f8.svg";